<template>
    <div v-if="loaded">
        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-card>
                  <div slot="header">
                    <h4 class="ml-2">
                      Detail Pasien
                    </h4>
                  </div>
                    <vs-row class="mt-4 ml-4" style="font-size:14px">
                        <vs-col class="w-1/2 lg:w-1/6">
                            <label class="vs-radio--label">Nama Pasien / No MR</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/3">
                            <label class="vs-radio--label">: {{detailData.patient.name}} / {{detailData.patient.patientNumber}}</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/6">
                            <label class="vs-radio--label">Tanggal Visit / Status</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/3">
                            <label class="vs-radio--label">: {{detailData.visitDate | formatDate}} / {{detailData.testStatusName}}</label>
                        </vs-col>
                      </vs-row>
                      <vs-row class="mt-2 ml-4 mb-4" style="font-size:14px">
                        <vs-col class="w-1/2 lg:w-1/6">
                            <label class="vs-radio--label">Tgl Lahir (Usia)</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/3">
                            <label class="vs-radio--label">: {{detailData.patient.dob | formatDate}} ({{detailData.patient.dob | calcAge1}})</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/6">
                            <label class="vs-radio--label">Jenis Kelamin</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/3">
                            <label class="vs-radio--label">: {{detailData.patient.gender.name}}</label>
                        </vs-col>
                    </vs-row>
                </vs-card>
            </div>
        </div>

        <patient :dataPatient="detailData" @bhp="bhpChg" :action="action" from="WorklistClinic" :instr="instr"/>

        <div class="vx-col w-full mt-8" vs-justify="center">
          <vs-row vs-w="12" vs-type="flex" vs-justify="center">
            <vs-button
              class="mr-4 mb-4"
              color="danger"
              @click="back"
              >
              Batal
            </vs-button>
            <vs-button
              class="mr-4 mb-4"
              icon-pack="feather"
              color="#6488e4"
              @click="onConfirm"
              >
              {{(action=='Start'?'Mulai Pemeriksaan':'Simpan')}}
            </vs-button>
          </vs-row>
    		</div>
    </div>
</template>

<script>
    import visit from "@/api/visit";
    import master from "@/api/master";
    import Patient from '../Patient';

    export default {
        data() {
            return {
                loaded: false,
                detailData: null,
                catatan: '',
                id: null,
                dataPatient: {},
                action: this.$route.params.action,
                bhp1: '',
                instr: []
            }
        },
        components: {
            Patient
        },
        mounted() {
    		  this.firstLoad();
        },
        methods: {
            bhpChg(arg) {
              this.bhp1 = arg;
            },
            /*physicianChg(arg) {
              this.detailData.physician = {id: arg};
            },*/
            back() {
              if (this.$route.params.from==='clinic') {
                this.$router.push({name:'worklist-klinik'});
              }

              if (this.$route.params.from==='pcr') {
                this.$router.push({name:'worklist-pcr'});
              }
            },
            onConfirm() {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'warning',
                    title: `Konfirmasi`,
                    text: (this.action=='Start'?'Mulai Pemeriksaan ?':'Edit Pemeriksaan ?'),
                    acceptText: 'Ya',
                    cancelText: 'Tidak',
                    accept: this.saveData
                });
            },
            saveData() {
                this.loading = true;
                let config = {
                    headers: {
                        "content-type": "application/json"
                    }
                };

                let model = { id: this.id };
                if (this.action==='Start') {
                  let instx = [];
                  for (var i=0; i<this.instr.length; i++) {
                    if (this.instr[i].status) {
                      instx.push({id: this.instr[i].id })
                    }
                  }

                  model.instrument = instx;
                  model.usage = { id : this.bhp1}
                  visit.start(model, config)
                    .then(res => {
                      if (res.data.status) {
                        this.$vs.notify({
                          title: "Informasi",
                          time: 3000,
                          text: "Mulai Pemeriksaan Berhasil",
                          color: "success",
                          position: "top-right"
                        });

                        this.$router.push({name: 'worklist-klinik'});
                      } else {
                        this.$vs.notify({
                          title: "Terjadi Kesalahan",
                          time: 3000,
                          text: res.data.message,
                          color: "danger",
                          position: "top-right"
                        });
                      }
                    })
                    .catch(error => {
                      if (error.response) {
                        this.$vs.notify({
                          title: "An Error Occured",
                          time: 3000,
                          text: error.response.data.message,
                          color: "danger",
                          position: "top-right"
                        });
                      }
                    })
                    .finally(() => (this.$vs.loading.close()));
                }

                if (this.action==='Update') {
                  let test = [];
                  for (var i=0; i<this.listTestPatientAdd.length; i++) {
                    test.push({id: this.listTestPatientAdd[i].id })
                  }
                  model.test = test;
                  visit.addTest(model, config)
                    .then(res => {
                      if (res.data.status) {
                        this.$vs.notify({
                          title: "Informasi",
                          time: 3000,
                          text: "Tambah Pemeriksaan Berhasil",
                          color: "success",
                          position: "top-right"
                        });

                        this.$router.push({name: 'worklist-klinik'});
                      } else {
                        this.$vs.notify({
                          title: "Terjadi Kesalahan",
                          time: 3000,
                          text: res.data.message,
                          color: "danger",
                          position: "top-right"
                        });
                      }
                    })
                    .catch(error => {
                      if (error.response) {
                        this.$vs.notify({
                          title: "An Error Occured",
                          time: 3000,
                          text: error.response.data.message,
                          color: "danger",
                          position: "top-right"
                        });
                      }
                    })
                    .finally(() => (this.$vs.loading.close()));
                }
            },
            async firstLoad() {
                let idx = this.$route.params.id;
                if (idx) {
                    const xmodel = await visit.getDetailV2(idx);
                    this.detailData = xmodel.data.data[0];
                    this.loaded = true;
                    this.id = idx;
                    this.getInstrument();
                }
            },
            async getInstrument() {
              var frms = await visit.listVisitInstrument(this.id);
              if (frms.data.status) {
                for (var i=0; i<frms.data.data.length; i++) {
                  this.instr.push({
                    id: frms.data.data[i].id,
                    name: frms.data.data[i].name,
                    status: true,
                  })
                }
              }
            }
        }
    }
</script>
